import React from "react";
import "./Goals.css";
import { SkeletonBar } from "../../../components/Skeleton/Skeleton";

/* Grid of shimmer cards shaped like the archived-goal cards.
   Used BOTH as the in-page data-loading state (inside ArcheivedGoals)
   and inside the full-page route fallback below. */
export const ArchivedCardsSkeleton = () => (
    <div className="gp-cards">
        {Array.from({ length: 6 }).map((_, i) => (
            <div className="gp-skl-card" key={i}>
                <div className="gp-chead">
                    <span className="cd-skl" style={{ width: 34, height: 34, borderRadius: 10 }} />
                    <span className="cd-skl" style={{ flex: 1, height: 14, borderRadius: 6 }} />
                </div>
                <div className="gp-body">
                    <div className="gp-metrics">
                        {Array.from({ length: 3 }).map((_, j) => (
                            <div className="gp-metric" key={j}>
                                <SkeletonBar w={92 + j * 20} h={11} />
                                <SkeletonBar w={74} h={12} />
                            </div>
                        ))}
                    </div>
                </div>
                <div className="gp-acts">
                    <span className="cd-skl" style={{ flex: 1, height: 34, borderRadius: 9 }} />
                    <span className="cd-skl" style={{ flex: 1, height: 34, borderRadius: 9 }} />
                </div>
            </div>
        ))}
    </div>
);

/* Full-page skeleton used as the lazy-route Suspense fallback so opening
   the Archived Goals page shows a page-specific placeholder instead of the
   generic <Loader/> spinner while the chunk downloads. */
const ArchivedGoalsSkeleton = () => (
    <div className="page-content-wraper goalspage">
        <div className="gp-head">
            <span className="gp-btn gp-icon gp-back" style={{ opacity: 0.55 }}>
                <svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6" /></svg>
            </span>
            <div className="gp-headings">
                <h1 className="gp-title">Archived Goals</h1>
                <p className="gp-sub">Goals &middot; Archived</p>
            </div>
        </div>
        <ArchivedCardsSkeleton />
    </div>
);

export default ArchivedGoalsSkeleton;
